export const enum ModalVisibilityStatus {
    None,
    AddPlayer,
    AddQuestions,
    BonusProtest,
    CustomizeGameFormat,
    ExportToJson,
    ExportToSheets,
    Font,
    Help,
    ImportFromQBJ,
    ImportGame,
    Message,
    NewGame,
    RenamePlayer,
    RenameTeam,
    ReorderPlayers,
    Scoresheet,
    ThrowOutQuestion,
    TossupProtest,
}
